import { Component, OnInit } from '@angular/core';

import { LegalSystemPage } from '../../shared/legal-system.model';
import { LegalSystemsService } from '../../services/legal-systems.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent implements OnInit {

  constructor (private legal: LegalSystemsService) {}

  page$!: Observable<LegalSystemPage>
  ngOnInit (): void {
      this.page$ = this.legal.getByKey('contact')
  }

  trackById (index: number, item: { id: number }): number {
    return item.id
  }

  trackByIndex (index: number): number {
    return index
  }

}
